/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientRequestSummary
 */
export interface HchbPatientRequestSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    status: HchbPatientRequestSummaryStatusEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HchbPatientRequestSummary
     */
    request_payload: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HchbPatientRequestSummary
     */
    response_payload?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    error_message?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientRequestSummary
     */
    updated_at?: string;
}


/**
 * @export
 */
export const HchbPatientRequestSummaryStatusEnum = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type HchbPatientRequestSummaryStatusEnum = typeof HchbPatientRequestSummaryStatusEnum[keyof typeof HchbPatientRequestSummaryStatusEnum];


/**
 * Check if a given object implements the HchbPatientRequestSummary interface.
 */
export function instanceOfHchbPatientRequestSummary(value: object): value is HchbPatientRequestSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('request_payload' in value) || value['request_payload'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function HchbPatientRequestSummaryFromJSON(json: any): HchbPatientRequestSummary {
    return HchbPatientRequestSummaryFromJSONTyped(json, false);
}

export function HchbPatientRequestSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientRequestSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'status': json['status'],
        'request_payload': json['request_payload'],
        'response_payload': json['response_payload'] == null ? undefined : json['response_payload'],
        'error_message': json['error_message'] == null ? undefined : json['error_message'],
        'created_at': json['created_at'],
        'updated_at': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function HchbPatientRequestSummaryToJSON(json: any): HchbPatientRequestSummary {
    return HchbPatientRequestSummaryToJSONTyped(json, false);
}

export function HchbPatientRequestSummaryToJSONTyped(value?: HchbPatientRequestSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'status': value['status'],
        'request_payload': value['request_payload'],
        'response_payload': value['response_payload'],
        'error_message': value['error_message'],
        'created_at': value['created_at'],
        'updated_at': value['updated_at'],
    };
}

